import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiPlus, FiSettings } from 'react-icons/fi';
import { useBrand } from '../context/BrandContext';
import './BrandSwitcher.css';

function BrandSwitcher() {
  const { brands, currentBrand, switchBrand, loading } = useBrand();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (loading) {
    return <div className="brand-switcher-loading">Loading...</div>;
  }

  if (!currentBrand && brands.length === 0) {
    return (
      <Link to="/admin/brands/new" className="brand-switcher-create">
        <FiPlus /> Create Your First Brand
      </Link>
    );
  }

  return (
    <div className="brand-switcher" ref={dropdownRef}>
      <button
        className="brand-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="brand-info">
          {currentBrand?.logo ? (
            <img src={currentBrand.logo} alt="" className="brand-logo" />
          ) : currentBrand ? (
            <div
              className="brand-logo-placeholder"
              style={{ backgroundColor: currentBrand?.brandColor || '#fc0202' }}
            >
              {currentBrand?.name?.charAt(0)}
            </div>
          ) : (
            <div
              className="brand-logo-placeholder all-brands"
              style={{ backgroundColor: '#6366f1' }}
            >
              *
            </div>
          )}
          <span className="brand-name">{currentBrand?.name || 'All Organisations'}</span>
        </div>
        <FiChevronDown className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <div className="brand-dropdown">
          <div className="brand-dropdown-header">Switch Organisation</div>

          <div className="brand-list">
            {/* All Brands option */}
            <button
              className={`brand-option ${!currentBrand ? 'active' : ''}`}
              onClick={() => {
                switchBrand(null);
                setIsOpen(false);
              }}
            >
              <div
                className="brand-option-logo-placeholder all-brands"
                style={{ backgroundColor: '#6366f1' }}
              >
                *
              </div>
              <span className="brand-option-name">All Organisations</span>
              {!currentBrand && (
                <span className="brand-option-check">✓</span>
              )}
            </button>

            {brands.map(brand => (
              <button
                key={brand._id}
                className={`brand-option ${brand._id === currentBrand?._id ? 'active' : ''}`}
                onClick={() => {
                  switchBrand(brand._id);
                  setIsOpen(false);
                }}
              >
                {brand.logo ? (
                  <img src={brand.logo} alt="" className="brand-option-logo" />
                ) : (
                  <div
                    className="brand-option-logo-placeholder"
                    style={{ backgroundColor: brand.brandColor || '#fc0202' }}
                  >
                    {brand.name.charAt(0)}
                  </div>
                )}
                <span className="brand-option-name">{brand.name}</span>
                {brand._id === currentBrand?._id && (
                  <span className="brand-option-check">✓</span>
                )}
              </button>
            ))}
          </div>

          <div className="brand-dropdown-footer">
            <Link
              to="/admin/brands/new"
              className="brand-action"
              onClick={() => setIsOpen(false)}
            >
              <FiPlus /> Add Organisation
            </Link>
            <Link
              to="/admin/brands"
              className="brand-action"
              onClick={() => setIsOpen(false)}
            >
              <FiSettings /> Manage Organisations
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default BrandSwitcher;
